<template>
    <div>
        <Fieldset
            heading="Auctioneer"
            v-show="form.account_details_form.fields.auctioneer_id.type == 'select'"
        >
            <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                <div class="col-span-2">
                    <FormField :field="form.account_details_form.fields.auctioneer_id" namespace="account_details" :name="'auctioneer_id'" class="mb-4" />
                </div>
            </div>
        </Fieldset>

        <Fieldset heading="Account Owner">
            <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                <div class="col-span-2">
                    <FormField :field="form.account_details_form.fields.ownership_type" namespace="ui" :name="'ownership_type'" class="mb-4" />
                </div>
                <div v-if="form.account_details_form.fields.ownership_type.value === 'organisation'" class="col-span-2">
                    <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                        <div class="col-span-1">
                            <AccountAddOrganisation
                                :auctioneer_id="form.account_details_form.fields.auctioneer_id.value"
                                :disabled="typeof form.account_details_form.fields.new_organisation_name.value === 'string' && form.account_details_form.fields.new_organisation_name.value.length > 0"
                                v-on:value_update="org => updateOrganisationField(org)"
                            />
                        </div>
                        <div class="col-span-1">
                            <FormField :field="form.account_details_form.fields.new_organisation_name" namespace="account_details_form" :name="'new_organisation_name'" class="mb-4" />
                        </div>
                    </div>
                </div>
                <div class="col-span-2">
                    <FormField :field="form.account_details_form.fields.email" namespace="ui" :name="'email'" class="mb-4" />
                    <FormField :field="form.account_details_form.fields.telephone_number" namespace="ui" :name="'telephone_number'" class="mb-4" />
                </div>

<!--                <div class="col-span-2">-->
<!--                    <FormField :field="form.account_details_form.fields.create_user_account" namespace="ui" :name="'create_user_account'" class="mb-4" />-->
<!--                </div>-->
                <div v-if="form.account_details_form.fields.user_first_name.active" class="col-span-1">
                    <FormField :field="form.account_details_form.fields.user_first_name" namespace="account_details_form" :name="'user_first_name'" class="mb-4" />
                </div>
                <div v-if="form.account_details_form.fields.user_last_name.active" class="col-span-1">
                    <FormField :field="form.account_details_form.fields.user_last_name" namespace="account_details_form" :name="'user_last_name'" class="mb-4" />
                </div>
<!--                <div v-if="form.account_details_form.fields.user_email.active" class="col-span-2">-->
<!--                    <FormField :field="form.account_details_form.fields.user_email" namespace="account_details_form" :name="'user_email'" class="mb-4" />-->
<!--                </div>-->
                <div class="col-span-2">
                    <AccountShowSimilar
                        v-if="form.account_details_form.fields.auctioneer_id.value"
                        :auctioneer_id="form.account_details_form.fields.auctioneer_id.value"
                        :account_name="form.account_details_form.fields.name.value"
                        :user_name="`${form.account_details_form.fields.user_first_name.value} ${form.account_details_form.fields.user_last_name.value}`"
                        :new_organisation_name="form.account_details_form.fields.new_organisation_name.value"
                        v-on:similar_accounts_updated="count => {
                            state.similar_accounts_count = count
                        }"
                    />
                </div>
            </div>
        </Fieldset>

        <Fieldset heading="Account Information" v-show="form.account_details_form.fields.ownership_type.value">
            <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                <div class="col-span-2">
                    <FormField :field="form.account_details_form.fields.name" namespace="account_details_form" :name="'name'" class="mb-4" />
                </div>
                <div class="col-span-1">
                    <AccountSetAccountCode
                        v-on:value_update="value => updateField(form.account_details_form.fields.code, value)"
                        :auctioneer_id="form.account_details_form.fields.auctioneer_id.value"
                        :refresh_flag="state.account_code_refresh_flag"
                        class="mb-2"
                    />
                </div>
                <div class="col-span-1">
                    <FormField :field="form.account_details_form.fields.type" namespace="account_details" :name="'type'" class="mb-6" />
                </div>
<!--                <div v-if="form.account_details_form.fields.auctioneer_id.value" class="col-span-2">-->
<!--                    <FormField :field="form.ui.fields.has_parent" namespace="ui" :name="'has_parent'" class="mb-4" />-->
<!--                    <AccountAddParent-->
<!--                        v-on:value_update="value => updateField(form.account_details_form.fields.parent_id, value)" :auctioneer_id="form.account_details_form.fields.auctioneer_id.value" v-if="form.ui.fields.has_parent.value" />-->
<!--                </div>-->
            </div>
        </Fieldset>

        <div v-show="form.account_details_form.fields.ownership_type.value" class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-8">

            <Fieldset heading="Seller" subheading="This account can be the seller of items on Auction365" class="col-span-1" :color="form.ui.fields.is_seller ? 'blue' : 'gray'">
                <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                    <div class="col-span-2">
                        <FormField v-if="account_type !== 'sellers'" :field="form.ui.fields.is_seller" namespace="seller" :name="'is_seller'" class="mb-4" />
                        <p v-else class="font-medium mb-2">Account must be a seller</p>
                    </div>
                </div>
            </Fieldset>

            <Fieldset heading="Buyer" subheading="This account can be the buyer of items on Auction365" class="col-span-1" :color="form.ui.fields.is_buyer ? 'blue' : 'gray'">
                <div class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-4">
                    <div class="col-span-2">
                        <FormField v-if="account_type !== 'buyers'" :field="form.ui.fields.is_buyer" namespace="buyer" :name="'is_buyer'" class="mb-4" />
                        <p v-else class="font-medium mb-2">Account must be a buyer</p>
                    </div>
                    <div v-if="form.ui.fields.is_buyer.value" class="col-span-2">
                        <FormField :field="form.buyer_details_form.fields.buyer_nextgear_id" namespace="buyer" :name="'buyer_nextgear_id'" class="mb-4" />
                    </div>
                </div>
            </Fieldset>

        </div>



        <div v-show="form.account_details_form.fields.ownership_type.value" class="min-w-0 flex-1 px-0 md:grid md:grid-cols-2 md:gap-8">
            <div class="col-span-1">
                <Fieldset heading="Address" subheading="(Optional) the account's default address">
                    <AccountAddLocation v-on:value_update="value => updateField(form.account_details_form.fields.location, value)" :show_table="true" />
                </Fieldset>
            </div>

            <div class="col-span-1">
                <Fieldset heading="Aliases" subheading="(Optional) Has this account ever been known by another name or account code?">
                    <AccountAddAlias v-on:value_update="value => updateField(form.account_details_form.fields.aliases, value)" :show_table="true" />
                </Fieldset>
            </div>
        </div>


        <div class="py-4 sm:pt-6 text-right">
            <Message :active="!form.ui.fields.is_buyer.value || !form.ui.fields.is_seller.value" type="error" heading="Accounts must be created as a seller and a buyer" body="We're temporarily requiring that all newly created accounts must be set up as both a seller and a buyer." class="text-left mb-4" />
            <Button v-if="cancelAction" width="w-auto" class="mr-2" color="text-blue" :onClick="() => cancelAction()">Cancel</Button>
            <Button width="w-auto" class="mr-2" :onClick="() => saveAccount(state.require_confirm, false)" :disabled="!form.ui.fields.is_buyer.value || !form.ui.fields.is_seller.value">Save</Button>
            <Button v-if="enable_add_another" width="w-auto" :onClick="() => saveAccount(state.require_confirm, true)" :disabled="!form.ui.fields.is_buyer.value || !form.ui.fields.is_seller.value">Save & add another</Button>
        </div>

    </div>

    <Modal v-on:close="closeConfirmModal" :active="state.confirm_modal_active" size="sm">
        <div class="lg:flex text-center justify-center mb-8">
            <h3 class="text-xl text-center leading-6 font-medium text-gray-900">Warning!</h3>
        </div>

        <div class="text-center mb-8">
            <p>1 or more accounts already exist with a similar or identical name, are you sure you want to proceed?</p>
        </div>

        <Button :onClick="() => saveAccount(false, state.add_another)" width="w-full" color="red">Yes, save account</Button>
        <Button :onClick="() => closeConfirmModal()" width="w-full" color="text-blue" class="mt-2">Cancel</Button>

    </Modal>

</template>

<script>
import { useAccountStore } from '@sto/account.store'
import { useAuctioneerStore } from '@sto/auctioneer.store'
import { useAuthStore } from '@sto/auth.store'
import { useSystemStore } from '@sto/system.store'
import { useRouter } from 'vue-router'
import { isValid, isValidField, getPayload, applyErrors } from '@lib/helpers'
import {onMounted, reactive, watch, computed} from 'vue'

import AccountSetAccountCode from "@par/account/AccountSetAccountCode.vue";
import AccountSetAccountName from "@par/account/AccountSetAccountName.vue";
import AccountSetAccountUserEmail from '@par/account/AccountSetAccountUserEmail.vue'
import AccountAddAlias from "@par/account/AccountAddAlias.vue";
import AccountAddLocation from "@par/account/AccountAddLocation.vue";
import AccountAddParent from "@par/account/AccountAddParent.vue";
import AccountShowSimilar from "@par/account/AccountShowSimilar.vue";
import AccountAddOrganisation from '@par/account/AccountAddOrganisation.vue';

export default {
    props: ['auctioneer_id', 'enable_add_another', 'on_complete_navigate_to', 'account_type', 'cancelAction'],
    components: {
        AccountSetAccountCode,
        AccountSetAccountName,
        AccountSetAccountUserEmail,
        AccountAddAlias,
        AccountAddLocation,
        AccountAddParent,
        AccountShowSimilar,
        AccountAddOrganisation
    },
    setup(props, {emit}) {

        const ACCOUNT_STORE = useAccountStore()
        const AUCTIONEER_STORE = useAuctioneerStore()
        const AUTH_STORE = useAuthStore()
        const SYSTEM_STORE = useSystemStore()
        const ROUTER = useRouter()

        const state = reactive({
            unique_code_timeout: null,
            unique_code_message: '<strong class="font-semibold">Enter a unique buyer code</strong> (letters, numbers, hyphens and underscores only)',
            unique_code_message_class: 'text-gray-700',
            unique_code: false,
            add_another: false,
            confirm_modal_active: false,
            require_confirm: false,
            similar_accounts_count: 0,
            account_code_refresh_flag: 0,
        })

        const form = reactive({
            account_details_form: {
                loading: false,
                fields: {
                    auctioneer_id: {
                        active: true,
                        label: 'Who are they a customer of',
                        type: 'select',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        options: [],
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },

                    email: {
                        active: true,
                        label: 'Primary Email Address',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [
                            {type: 'characters', value: 'email'},
                        ],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    telephone_number: {
                        active: true,
                        label: 'Primary Telephone <span class="text-gray-400">(Optional)</span>',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },

                    organisation_id: {
                        active: true,
                        label: '',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    new_organisation_name: {
                        active: true,
                        label: 'Create a new business',
                        type: 'text',
                        value: '',
                        placeholder: 'New business name',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },

                    user_first_name: {
                        active: true,
                        label: 'First name',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    user_last_name: {
                        active: true,
                        label: 'Last name',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    user_email: {
                        active: true,
                        label: 'Email address',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [
                            //{type: 'characters', value: 'email'},
                        ],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    code: {
                        active: true,
                        label: 'Account Code',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [
                            { type: 'characters', value: 'slug' },
                        ],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    name: {
                        active: true,
                        label: 'Account name',
                        type: 'text',
                        value: '',
                        placeholder: 'e.g. Person or business name',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    type: {
                        active: true,
                        label: 'Account Type',
                        type: 'select',
                        value: 'main',
                        placeholder: '',
                        stored_value: '',
                        options: [
                            { label: 'Main', value: 'main' },
                            { label: 'Company', value: 'company' },
                            { label: 'Trade', value: 'trade' },
                            { label: 'Private', value: 'private' },
                            { label: 'Auctioneer', value: 'auctioneer' },
                            { label: 'Other', value: 'other' }
                        ],
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    parent_id: {
                        active: true,
                        label: '',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    location: {
                        active: true,
                        label: '',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    aliases: {
                        active: true,
                        label: '',
                        type: 'hidden',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    ownership_type: {
                        active: true,
                        label: 'Is this account for a business or an individual?',
                        type: 'select',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        options: [
                            { label: 'Please select...', value: null },
                            { label: 'Business', value: 'organisation' },
                            { label: 'Individual', value: 'user' }
                        ],
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    create_user_account: {
                        active: true,
                        label: 'Invite the account owner to join Auction365?',
                        type: 'toggle',
                        value: true,
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        toggle_no_margin: true,
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            },

            seller_details_form: {
                loading: false,
                fields: {

                }
            },

            buyer_details_form: {
                loading: false,
                fields: {
                    buyer_v12_id: {
                        active: true,
                        label: 'V12 ID (Optional)',
                        type: 'text',
                        value: '',
                        placeholder: 'The Buyer\'s V12 account ID',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                    buyer_nextgear_id: {
                        active: true,
                        label: 'Nextgear ID (Optional)',
                        type: 'text',
                        value: '',
                        placeholder: 'The Buyer\'s Nextgear account ID',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    }
                }
            },

            ui: {
                fields: {

                    is_seller: {
                        active: true,
                        label: 'Account is a seller?',
                        type: 'toggle',
                        value: true,
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        toggle_no_margin: true,
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: props.account_type === 'seller'
                    },
                    is_buyer: {
                        active: true,
                        label: 'Account is a buyer?',
                        type: 'toggle',
                        value: true,
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        toggle_no_margin: true,
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: props.account_type === 'buyers'
                    },
                    has_parent: {
                        active: true,
                        label: 'Assign to a parent account',
                        type: 'toggle',
                        value: false,
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        hide_hint: true,
                        toggle_no_margin: true,
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            },
        })

        const account_is_seller = computed(() => form.ui.fields.is_seller.value)
        const account_is_buyer = computed(() => form.ui.fields.is_buyer.value)

        const account_name = computed(() => {
            switch (form.account_details_form.fields.ownership_type.value) {
                case 'organisation':
                    return form.account_details_form.fields.new_organisation_name.value
                case 'user':
                    return `${form.account_details_form.fields.user_first_name.value} ${form.account_details_form.fields.user_last_name.value}`
                default:
                    return ''
            }

        })

        const updateField = (field, value) => {
            field.value = value
        }

        const setUserAuctioneerOptions = () => {
            let options = []

            AUTH_STORE.user.organisation_auctioneers.forEach(a => {
                options.push({ value: a.id, label: a.organisation_name })
            })

            form.account_details_form.fields.auctioneer_id.options = options
            form.account_details_form.fields.auctioneer_id.type = options.length === 1 ? 'hidden' : 'select'

            if (props.auctioneer_id && options.filter(o => o.value == props.auctioneer_id).length) {
                // supplied auctioneer_id is in the user's auctioneers
                form.account_details_form.fields.auctioneer_id.value = props.auctioneer_id
                form.account_details_form.fields.auctioneer_id.type = 'hidden'

            } else if (options.length > 0) {
                // user has auctioneers, pre-select the first
                form.account_details_form.fields.auctioneer_id.value = options[0].value
            }
        }

        const resetCodeAvailabilityMessage = () => {
            state.unique_code_message = '<strong class="font-semibold">Enter a unique buyer code</strong> (letters, numbers, hyphens and underscores only)'
            state.unique_code_message_class = 'text-gray-700'
        }

        const confirmSave = () => {

        }

        const saveAccount = async (require_confirm = false, add_another = false) => {

            state.add_another = add_another;

            if (form.account_details_form.loading || !isValid(form.account_details_form.fields)) {
                return window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }

            if (require_confirm) return state.confirm_modal_active = true

            form.account_details_form.loading = true

            try {
                let payload = getPayload(form.account_details_form.fields)
                // payload.is_seller = account_is_seller.value
                //     ? 1
                //     : 0
                // payload.is_buyer = account_is_buyer.value
                //     ? 1
                //     : 0

                payload.is_seller = 1
                payload.is_buyer = 1

                const account = await ACCOUNT_STORE.create(payload)
                SYSTEM_STORE.addSuccess('New account created!')

                if (props.on_complete_navigate_to) {
                    !add_another ? ROUTER.push({name: props.on_complete_navigate_to})
                        : resetState()
                }

                emit( 'account_created', account )

            } catch (error) {
                console.error('ACCOUNT_STORE.create error', error)
                SYSTEM_STORE.addError('Error', error?.message || 'There was an error creating the account')

            } finally {
                form.account_details_form.loading = false
                state.add_another = false
                state.confirm_modal_active = false
                state.require_confirm = false
            }
        }

        const resetState = () => {

            state.similar_accounts_count = 0

            state.account_code_refresh_flag++

            state.unique_code_timeout = null
            state.unique_code_message = '<strong class="font-semibold">Enter a unique account code</strong> (letters, numers, hyphens and underscores only)'
            state.unique_code_message_class = 'text-gray-700'

            form.account_details_form.fields.ownership_type.value = null
            form.account_details_form.fields.ownership_type.pristine = true

            form.account_details_form.fields.code.value = ''
            form.account_details_form.fields.code.pristine = true

            form.account_details_form.fields.email.value = ''
            form.account_details_form.fields.email.pristine = true

            form.account_details_form.fields.telephone_number.value = ''
            form.account_details_form.fields.telephone_number.pristine = true

            form.account_details_form.fields.new_organisation_name.value = ''
            form.account_details_form.fields.new_organisation_name.pristine = true

            form.account_details_form.fields.name.value = ''
            form.account_details_form.fields.name.pristine = true

            form.account_details_form.fields.user_first_name.value = ''
            form.account_details_form.fields.user_first_name.pristine = true

            form.account_details_form.fields.user_last_name.value = ''
            form.account_details_form.fields.user_last_name.pristine = true

            form.buyer_details_form.fields.buyer_nextgear_id.value = ''
            form.buyer_details_form.fields.buyer_nextgear_id.pristine = true

            form.buyer_details_form.fields.buyer_v12_id.value = ''
            form.buyer_details_form.fields.buyer_v12_id.pristine = true
        }

        const updateOrganisationField = organisation => {
            form.account_details_form.fields.organisation_id.value = organisation?.id || null

            form.account_details_form.fields.name.value = organisation?.name || ''
        }

        const closeConfirmModal = () => {
            state.confirm_modal_active = false
        }

        onMounted(() => {
            setUserAuctioneerOptions()
        })

        watch (
            () => form.ui.fields.has_parent.value,
            (new_value) => {
                if (!new_value) form.account_details_form.fields.parent_id.value = null
            }
        )

        watch (
            () => form.account_details_form.fields.auctioneer_id.value,
            (new_value) => {
                form.ui.fields.has_parent.value = false
                form.account_details_form.fields.parent_id.value = null
            }
        )

        watch (
            () => form.account_details_form.fields.ownership_type.value,
            () => {

                // reset the account name
                form.account_details_form.fields.name.value = ''
                form.account_details_form.fields.user_last_name.value = ''
                form.account_details_form.fields.user_first_name.value = ''
                form.account_details_form.fields.new_organisation_name.value = ''

                form.account_details_form.fields.organisation_id.value = null

                switch (form.account_details_form.fields.ownership_type.value) {
                    case 'organisation':

                        form.account_details_form.fields.new_organisation_name.active = true

                        form.account_details_form.fields.user_last_name.active = form.account_details_form.fields.create_user_account.value
                            ? true
                            : false
                        form.account_details_form.fields.user_first_name.active = form.account_details_form.fields.create_user_account.value
                            ? true
                            : false
                        break

                    case 'user':
                        form.account_details_form.fields.new_organisation_name.active = false
                        form.account_details_form.fields.user_last_name.active = true
                        form.account_details_form.fields.user_first_name.active = true
                        form.account_details_form.fields.type.value = 'private'
                        break
                    default:
                }
            }
        )

        watch (
            () => form.account_details_form.fields.create_user_account.value,
            () => {

                if (form.account_details_form.fields.ownership_type.value === 'user') {
                    form.account_details_form.fields.user_last_name.active = true
                    form.account_details_form.fields.user_first_name.active = true
                } else if (form.account_details_form.fields.ownership_type.value === 'organisation') {
                    form.account_details_form.fields.user_last_name.active = form.account_details_form.fields.create_user_account.value ? true : false
                    form.account_details_form.fields.user_first_name.active = form.account_details_form.fields.create_user_account.value ? true : false
                }

                form.account_details_form.fields.user_email.active = form.account_details_form.fields.create_user_account.value ? true : false
            }
        )

        watch (
            () => account_name.value,
            () => {
                form.account_details_form.fields.name.value = account_name.value
            }
        )

        watch (
            () => state.similar_accounts_count,
            () => {
                state.require_confirm = state.similar_accounts_count > 0
            }
        )

        watch (
            () => form.account_details_form.fields.organisation_id.value,
            () => {
                if (form.account_details_form.fields.organisation_id.value) {
                    form.account_details_form.fields.new_organisation_name.value = ''
                    form.account_details_form.fields.new_organisation_name.disabled = true
                    form.account_details_form.fields.new_organisation_name.required = false
                    form.account_details_form.fields.create_user_account.value = false
                    form.account_details_form.fields.create_user_account.active = false

                } else {
                    form.account_details_form.fields.new_organisation_name.disabled = false
                    form.account_details_form.fields.new_organisation_name.required = true
                    form.account_details_form.fields.create_user_account.active = true
                }
            }
        )

        watch (
            () => form.account_details_form.fields.new_organisation_name.value,
            () => {
                if (form.account_details_form.fields.new_organisation_name.value) {
                    form.account_details_form.fields.organisation_id.value = null
                }
            }
        )

        watch (
            () => form.account_details_form.fields.email.value,
            () => {
                form.account_details_form.fields.user_email.value = form.account_details_form.fields.email.value
            }
        )

        return {
            form,
            state,
            account_is_seller,
            account_is_buyer,
            saveAccount,
            updateField,
            updateOrganisationField,
            closeConfirmModal
        }
    }
}
</script>